module.exports = __webpack_public_path__ + "img/myStudents1.1121f805.png";